import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Users } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-24 px-4 bg-warmwhite" data-id="element-348" data-mp="31n3degnump2q">
      <div className="max-w-4xl mx-auto" data-id="element-349" data-mp="2no3vrsyr7ag2">
        <div className="text-center mb-12" data-id="element-350" data-mp="2nnc24nopvmsf">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-4" data-id="element-351" data-mp="2smyih5zudj5g">
            ¿Este material es para vos?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-352" data-mp="2dwhh1mn7it8k">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-cream p-8 rounded-2xl border border-cream-dark" data-id="element-353" data-mp="2ipalsaioe1kn">
            <div className="flex items-center gap-3 mb-6" data-id="element-354" data-mp="1uzyclancltic">
              <GraduationCap className="text-terracota" size={28} data-id="element-355" data-mp="1zyj48lojb4v6" />
              <h3 className="text-xl font-bold text-green" data-id="element-356" data-mp="3ackm5ps5nfeq">
                Está pensado para docentes de:
              </h3>
            </div>
            <ul className="space-y-3" data-id="element-357" data-mp="35ces62yexgth">
              {['Escuelas técnicas con orientación en alimentos', 'Escuelas agropecuarias con módulo de industrialización', 'Bachilleratos técnicos en tecnología de alimentos', 'Formación profesional en procesamiento de alimentos', 'Materias de industrialización, tecnología o procesamiento', 'Talleres de proyectos productivos con base alimentaria'].map((item, i) => <li key={i} className="flex items-start gap-2 text-ink text-sm" data-id="element-358" data-mp="30foa5a31sb5f" data-mpi={i}>
                  <span className="text-olive font-bold" data-id="element-359" data-mp="2vmv84tyyrgx1">•</span> {item}
                </li>)}
            </ul>
            <div className="mt-6 pt-6 border-t border-cream-dark" data-id="element-360" data-mp="27vzhw1a5otrw">
              <p className="text-sm font-bold text-green" data-id="element-361" data-mp="23vpdgt20ibf5">
                Nivel educativo principal:
              </p>
              <p className="text-sm text-slate" data-id="element-362" data-mp="6vktmkxbuzk0">
                Secundaria técnica y formación profesional
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-363" data-mp="gle8busrnush">
            <div className="bg-white p-6 rounded-2xl border border-cream-dark shadow-sm" data-id="element-364" data-mp="3p2iopydf9tvd">
              <h4 className="font-bold text-terracota mb-2" data-id="element-365" data-mp="3u0aplhw1oqbp">
                Importante sobre las normativas:
              </h4>
              <p className="text-sm text-ink leading-relaxed" data-id="element-366" data-mp="2vu56nv9wvin">
                Los principios técnicos son aplicables en toda la región
                hispanohablante. Las normativas sanitarias y de rotulado varían
                por país y deben verificarse localmente.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl border border-cream-dark shadow-sm" data-id="element-367" data-mp="2yqnra70938wa">
              <div className="flex items-center gap-2 mb-2" data-id="element-368" data-mp="2tt5oyzgqnrx9">
                <Users className="text-olive" size={20} data-id="element-369" data-mp="2p0vs0zh7hrlh" />
                <h4 className="font-bold text-green" data-id="element-370" data-mp="2ozav537f5wkg">
                  ¿No sos docente de alimentos pero trabajás con proyectos
                  productivos?
                </h4>
              </div>
              <p className="text-sm text-ink leading-relaxed" data-id="element-371" data-mp="2f14wcugwt6jt">
                El sistema también puede ser útil para instructores,
                capacitadores y coordinadores de talleres técnicos que trabajen
                con procesamiento o industrialización de alimentos.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}